import { I18n } from 'react-redux-i18n'
import { isValidText } from '../../../utils/helpers'

export default (delegation) => {
  let errors = {}

  if (!delegation.name) errors.name = I18n.t('dashboard_errors_required-field')
  else if (!isValidText(delegation.name)) errors.name = I18n.t(`dashboard_errors_${delegation.errors.name}`)

  if (delegation.city && !isValidText(delegation.city)) {
    errors.city = I18n.t('dashboard_errors_not-valid-name')
  }

  if (delegation.province && !isValidText(delegation.province)) {
    errors.province = I18n.t('dashboard_errors_not-valid-name')
  }

  if (delegation.country && !isValidText(delegation.country)) {
    errors.country = I18n.t('dashboard_errors_not-valid-name')
  }

  if (!delegation.brand) {
    errors.brand = I18n.t('dashboard_errors_required-field')
  }

  return errors
}
